///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { uniqBy } from "lodash";

import Avatar from "../components/Avatar";

export const getPricingRegionUsersAvatars = bid => {
  const avatars = [];

  const distinctTruckloadPricingRegionAssignments =
    bid.truckloadPricingRegionAssignments &&
    uniqBy(bid.truckloadPricingRegionAssignments, p => p.userId);

  distinctTruckloadPricingRegionAssignments.map(t => {
    return avatars.push(
      <Avatar
        alt={t.fullName}
        className="align-bottom inline-block mb-0 mr-2"
        data-testid={`${t.userId}-pricing-region-users-avatar`}
        imageSource={t.profilePicture}
        key={`${t.userId} ${t.fullName}`}
        size={26}
        tooltipContent={<div>{t.fullName}</div>}
        textContent={`${t["firstName"][0]}${t["lastName"][0]}`}
        fontSize={10}
      />
    );
  });
  return avatars;
};

export default getPricingRegionUsersAvatars;
